import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotSites from './components/HotSites';
import LatestArticles from './components/LatestArticles';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '91导航',
  url: 'https://91daohang.com',
  description: '一站式网址导航与资源聚合平台，汇聚海量优质网址、热门工具与实用资源',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://91daohang.com/category/sousuo?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '91导航',
  url: 'https://91daohang.com',
  description: '一站式网址导航与资源聚合平台',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'contact@91daohang.com',
  },
};

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotSites />
        <LatestArticles />

        <section className="py-12 md:py-16 bg-secondary-50/50">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">
              开始你的高效上网体验
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mb-6 leading-relaxed">
              将91导航设为浏览器主页，每天打开浏览器就能快速访问你最需要的网站。
              告别繁琐的搜索和输入，一键直达目标网站。
            </p>
            <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium cursor-pointer hover:bg-primary-600 transition-colors">
              <i className="ri-bookmark-line"></i>
              <span>设为浏览器主页</span>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
    </>
  );
}